module.exports = __webpack_public_path__ + "static/img/share_coupon.d3ba312.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sharedHome/share_coupon.png
// module id = EZrO
// module chunks = 1